import React from 'react';
import {DataVisual} from './modules/dataVisual/DataVisual';
import {BannerTitle} from './modules/bannerTitle/BannerTitle';

export const App = () => {
  return (
    <div>
      <div className="App">
        <header className="App-header">
          <BannerTitle/>
          <DataVisual/>
          <div className="footer">
            Mina Gas Station is brought to you from Carbonara by <a href="https://westake.club">WeStake.Club⚡️</a>
          </div>
        </header>
      </div>
    </div>
  )
};
